const id = `p-progress-line`;

jQuery(document).on("bb:postHandleData", function (_event, data) {
  if (data && data.jumplist) {
    const jumplist = data.jumplist; //.filter(prop("ischapter"));
    const total = jumplist.length;
    if (total === 0) {
      for (let progress of document.querySelectorAll(`.${id}__inner`)) {
        progress.hidden = true;
      }
      return;
    }
    let last;
    for (let i = total - 1; i >= 0; i--) {
      if (["selected", "past"].includes(jumplist[i].status)) {
        last = i;
        break;
      }
    }
    if (last === undefined) {
      for (let progress of document.querySelectorAll(`.${id}__inner`)) {
        progress.hidden = true;
      }
      return;
    }
    for (let progress of document.querySelectorAll(`.${id}__inner`)) {
      progress.hidden = false;
      progress.max = total;
      progress.value = last + 1;
    }
  }
});
